/**
 * /* eslint-disable react/jsx-props-no-spreading
 *
 * @format
 */

import React from "react";
import styled from "styled-components";
import { Button } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";

import Confirm from "components/shared/Confirm";
import * as env from "constants/env";

let eqrcodeVersion = env.eqrcodeVersion === "true";

const primaryBtnStyle = {
  //   backgroundColor: "#229BFF",
  //   borderColor: "#229BFF",
  color: "#ffffff",
  minWidth: "76px",
  fontSize: "14px",
  borderRadius: "4px",
};

const cancelBtnStyle = {
  backgroundColor: "#E5E6EB",
  borderColor: "#E5E6EB",
  color: "#000000",
  width: "76px",
  fontSize: "14px",
  borderRadius: "4px",
};

const Container = styled.div`
  overflow-y: auto;
  max-height: 464px;
  padding: 20px 24px 10px 24px;
  text-align: center;
`;

const StyledTitle = styled.div`
  margin-top: 12px;
  margin-left: 1px;
  padding-top: 2px;
`;

const StyledDescription = styled.div`
  font-size: 16px;
  color: #2e2e2e;
  font-weight: 400;
`;

interface PropTypes {
  title: string;
  isLoading: boolean;
  onClose: () => void;
  onOk: () => void;
  isVisible: boolean;
}

const LogoutDlg = ({
  title,
  isLoading,
  onClose,
  isVisible,
  onOk,
  ...resProps
}: PropTypes) => {
  const buttons = (
    <>
      <Button
        onClick={() => {
          onClose();
        }}
        style={cancelBtnStyle}
      >
        Cancel
      </Button>
      <Button
        type="primary"
        onClick={() => {
          onOk();
        }}
        loading={isLoading}
        style={primaryBtnStyle}
        danger
      >
        Logout
      </Button>
    </>
  );

  const styles = {
    color: "#FF7D00",
    marginRight: "10px",
  };

  return (
    <Confirm
      title={
        <StyledTitle>
          <ExclamationCircleFilled rev style={styles} />
          {title}
        </StyledTitle>
      }
      onClose={() => {
        onClose();
      }}
      closable={false}
      buttons={buttons}
      width={390}
      bodyStyle={{ padding: "0" }}
      maskStyle={{}}
      isVisible={isVisible}
      wrapClassName="logout-dialog-wrap"
      {...resProps}
    >
      <Container>
        <StyledDescription>{`Are you going to logout ${
          eqrcodeVersion ? "Premium Service" : "horizon"
        }?`}</StyledDescription>
      </Container>
    </Confirm>
  );
};

export default LogoutDlg;
